import { check_serial_crc, clean_serial } from 'entities/device.add/lib/serial-utils';
import { getAPIErrorMessage } from 'api';
export const buy_h2000plus_firmware = (serial) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'BUY_H2000PLUS_FIRMWARE__REQUEST' });
    serial = clean_serial(serial);
    if (serial.length !== 12) {
        dispatch({
            type: 'BUY_H2000PLUS_FIRMWARE__FAIL',
            error: 'Серийный номер должен состоять из 12 символов',
        });
        return;
    }
    if (!check_serial_crc(serial)) {
        dispatch({
            type: 'BUY_H2000PLUS_FIRMWARE__FAIL',
            error: 'Некорректный серийный номер',
        });
        return;
    }
    try {
        const response = await api.buy_h2000plus_firmware(serial);
        dispatch({
            type: 'BUY_H2000PLUS_FIRMWARE__OK',
        });
        dispatch({
            type: 'BILLING_STATE__OK',
            data: response.billing_state,
        });
    }
    catch (error) {
        dispatch({
            type: 'BUY_H2000PLUS_FIRMWARE__FAIL',
            error: getAPIErrorMessage(error, 'Не удалось купить прошивку'),
        });
    }
};
